export enum DialogDisplayMode {
    Singular = 'singular',
    Tabbed = 'tabbed'
}
